import { ReactNode, createContext, useState } from "react";
import { Survey } from "../types/survey";

export interface ISurveyContext {
  currentSurvey?: Survey;
  setCurrentSurvey: (survey: Survey) => void;
}

export const SurveyContext = createContext<ISurveyContext | undefined>(
  undefined
);

interface SurveyProviderProps {
  children: ReactNode;
}

export const SurveyProvider = ({ children }: SurveyProviderProps) => {
  const [currentSurvey, setCurrentSurveyState] = useState<Survey>();

  const setCurrentSurvey = (survey: Survey) => {
    setCurrentSurveyState(survey);
  };

  return (
    <SurveyContext.Provider
      value={{
        currentSurvey,
        setCurrentSurvey,
      }}
    >
      {children}
    </SurveyContext.Provider>
  );
};
